/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appSlack_viewer$ref: FragmentReference;
declare export opaque type appSlack_viewer$fragmentType: appSlack_viewer$ref;
export type appSlack_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +slackEnabled: ?boolean,
    +newSlackEnabled: ?boolean,
  |},
  +$refType: appSlack_viewer$ref,
|};
export type appSlack_viewer$data = appSlack_viewer;
export type appSlack_viewer$key = {
  +$data?: appSlack_viewer$data,
  +$fragmentRefs: appSlack_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appSlack_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slackEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newSlackEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '0e686c947e0803d0d704bf57ae6355bc';

module.exports = node;
